import IsLoggedReducer from "./isLogged";
import IsMenuVisibleReducer from "./isMenuVisible";
import {combineReducers} from 'redux';

const allReducers = combineReducers({
    log_in : IsLoggedReducer,
    menu_vis : IsMenuVisibleReducer,
});

export default allReducers;